module.exports = __webpack_public_path__ + "img/Admin.6fed4bdf.png";